module.exports = __webpack_public_path__ + "img/attachment.1450c3ea.svg";